import React from "react";
import Tooltip from "views/pages/manage/common/customTooltip/CustomTooltip";
import RadioButton from "../../../studentTransfer/components/selectStudent/SelectionRationBtn";
import styles from "../../../studentTransfer/components/transfer.module.css"
import {
  CourseDetailsPopupById,
  EyeIcon,
} from "views/pages/manage/unAssigned/studentCharges/common";
import ViewRefundHistory from "./ViewRefundHistory";

const progActionMap = {
  APPL: "Application",
  BTCG: "Batch Change",
  CRCG: "Course Change",
  DISC: "Discontinuation",
  FOLO: "Discontinuation with Follow up",
  IBTR: "Inter-Branch Transfer",
  MATR: "Matriculation",
  RADM: "Readmit",
};

export const getColumnList = (
  onStudentSelection,
  selectedStudentApplicationId,
  buMap,
  navigateToGivenPath
) => [
    {
      field: "psid",
      headerName: "PSID",
      sortable: true,
      width: "13.5%",
      render: (row) => (
        <div className="d-flex align-item-center mr-2">
          <RadioButton
            currentId={row?.applicationId}
            selectedId={selectedStudentApplicationId}
            row={row}
            onStudentSelection={onStudentSelection}
          />

          <div
            onClick={() =>
              navigateToGivenPath(`admin/edp/studentDetails/${row?.psid}`)
            }
            style={{ color: "#00B0F5", cursor: "pointer" }}
          >
            {row?.psid}
          </div>
        </div>
      ),
    },
    {
      field: "studentName",
      // width: "12.5%",
      headerName: "Student name",
      sortable: true,
      render: (row) => (
        <div className="ellipsis-text-container">{row?.studentName}</div>
      ),
    },
    {
      field: "applicationId",
      // width: "12.5%",
      headerName: "Application ID.",
      sortable: true,
      render: (row) => (
        <div className="ellipsis-text-container">{row?.applicationId}</div>
      ),
    },
    {
      field: "bu",
      headerName: "BU",
      // width: "12.5%",
      sortable: false,
      render: (row) => {
        const buKey = row?.businessAreaDispVal;
        const buDesc = buMap[buKey] || "N/A";
        return (
          <div className="d-flex gap-xs align-items-center">
            <div className="ellipsis-text-container">{buKey}</div>
            <Tooltip title={buDesc}>
              <div>
                <div>
                  <EyeIcon />
                </div>
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "cashierOffice",
      headerName: "Cashier Office",
      // width: "12.5%",
      sortable: false,
      render: (row) => {
        const buKey = row?.cashierOffice;
        const buDesc = buMap[buKey] || "N/A";
        return (
          <div className="d-flex gap-xs align-items-center">
            <div className="ellipsis-text-container">{buKey || "-"}</div>
            <Tooltip title={buDesc}>
              <div>
                <div>
                  <EyeIcon />
                </div>
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "courseId",
      headerName: "Course ID",
      // width: "12.5%",
      sortable: false,
      render: (row) => (
        <div className="d-flex align-items-center gap-xs" >
          <div className="ellipsis-text-container">{row?.courseId}</div>
          <CourseDetailsPopupById courseId={row?.courseId} cta={<EyeIcon />} />
        </div>
      ),
    },
    {
      field: "termDispVal",
      headerName: "Term",
      // width: "12.5%",
      sortable: false,
      render: (row) => (
        <div className="d-flex align-items-center gap-xs" >
          <div className="ellipsis-text-container">{row?.termDispVal}</div>
        </div>
      ),
    },

    {
      field: "career",
      headerName: "Career",
      sortable: false,
      // width: "12.5%",

      render: (row) => (
        <div className="ellipsis-text-container">{row?.academicCareerValue}</div>
      ),
    },
    {
      field: "progAction",
      headerName: "Prog. Action",
      sortable: false,
      // width: "12.5%",
      render: (row) => {
        const value = row?.programAction;
        const desc = progActionMap[value] || "N/A";
        return (
          <div className="d-flex align-items-center ellipsis-text-container gap-xs">
            <span className="mr-2">{value}</span>
            <Tooltip title={desc}>
              <div>
                <EyeIcon />
              </div>
            </Tooltip>
          </div>
        );
      },
    },

    // {
    //   field: "transferType",
    //   headerName: "Refund history",
    //   sortable: false,
    //   // width: "12.5%",
    //   render: (row) => (
    //     <div className="ellipsis-text-container">
    //       <ViewRefundHistory psid={row.psid}/>
    //     </div>
    //   ),
    // },
  ];
